import { render } from "./edit.vue?vue&type=template&id=c3fd4b78&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "@/assets/custom-outside.css?vue&type=style&index=0&id=c3fd4b78&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3fd4b78"]])

export default __exports__